/**
 * @function getFullEntrySlug - Формирование полного URL статьи
 */
export const getFullEntrySlug = (entryId: number, entrySlug: string, rubricSlug?: string): string => {
  const preparedRubricSlug = rubricSlug ? `/${rubricSlug}` : ''
  return `https://daily.afisha.ru${preparedRubricSlug}/${entryId}-${entrySlug}/`
}
